import React from 'react';
import DataRow from '../../components/DataRow/DataRow';

const Note = ({ note }) => {
    return (
        <DataRow value={note.body} dataType="String" />
    );
};

export default Note;